import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import SinglePaymentPage from './SingleNew/SinglePaymentPage';
import BulkPayment from './Bulk/BulkPaymentContainer';
import GroupCreation from '../Groups/CreateGroup/GroupCreationContainer';
import EditGroup from '../Groups/EditGroup/EditGroupContainer';
import GroupDetails from '../Groups/GroupDetails/GroupDetailsContainer';
import { usePermissions } from '../../providers/Permissions.provider';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useLockedFeatures } from '../../providers/LockedFeatures.provider';
import { JSX } from 'react';
import SinglePaymentContainer from './Single/SinglePaymentContainer';

const Routes = (): JSX.Element => {
  const { permissions } = usePermissions();
  const featureFlags = useModuleFeatureFlag('payment');
  const lockedFeatures = useLockedFeatures();

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.BulkPayments && !!lockedFeatures.PaymentsEnabled}
        showPermission
        path="/bulk-payment"
        exact
        component={BulkPayment}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.BulkPayments && !!lockedFeatures.PaymentsEnabled}
        showPermission
        path="/bulk-payment/group/:GroupID"
        exact
      >
        <GroupDetails type="Payment" />
      </ProtectedRoute>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.BulkPayments && !!lockedFeatures.PaymentsEnabled}
        showPermission
        path="/bulk-payment/create"
        exact
        component={GroupCreation}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.BulkPayments && !!lockedFeatures.PaymentsEnabled}
        showPermission
        path="/bulk-payment/edit/:GroupID"
        exact
        component={EditGroup}
      />

      <ProtectedRoute
        isAllowed={!!permissions.CreatePayments && featureFlags.isEnabled && !!lockedFeatures.PaymentsEnabled}
        showPermission
        exact
        path="/single-payment"
        component={SinglePaymentContainer}
      />
      <ProtectedRoute
        isAllowed={!!permissions.CreatePayments && featureFlags.isEnabled && !!lockedFeatures.PaymentsEnabled}
        showPermission
        exact
        path="/single-payment-new"
        component={SinglePaymentPage}
      />
    </Switch>
  );
};

export default Routes;
